import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getDriverDispatchById } from '../../../actions/ddActions';
import { makeStyles } from '@material-ui/core/styles';
import { Table } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useTranslation } from 'react-i18next';
import DriverTransfer from '../DriverTransfer';

const useStyles = makeStyles((theme) => ({
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    },
    tableRowColor: { 
        background: theme.palette.background.default
    },
    titlesFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        overflowX: 'auto',
        marginBottom: 10
    },
    title: {
        whiteSpace: "nowrap"
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    tableCellContentFormat: { 
        textAlign: 'center' 
    }
}));

function SearchTableHistory(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('driverDispatch');

    const ddManagement = useSelector(state => state.ddReducer)

    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [driverId, setDriverId] = useState('');
    const [transferId, setTransferId] = useState('');
    const [listCate, setListCate] = useState([]);

    const columns = [
        t("driver_id"),
        t('driver'),
        t("date"),
        t("dispatch_number"),
        t("return_package"),
        t("transfer_package"),
        t("unscanned_package"),
        t("dispatch_batch")
    ];

    const display = [
        'driver_id',
        'driver_name',
        'update_time',
        'total_scanned',
        'total_returned',
        'total_transfered',
        'total_unscanned'
    ]

    useEffect(() => {
        if(ddManagement.getDriverDispatchBetween) {
            sortByTimeDec(ddManagement.getDriverDispatchBetween);
        }
    }, [ddManagement.getDriverDispatchBetween])
    useEffect(() => {
        if(ddManagement.getDriverDispatchById) {
            sortByTimeDec(ddManagement.getDriverDispatchById);
        }
    }, [ddManagement.getDriverDispatchById])

    function sortByTimeDec(arr) {
        arr.sort(function(a,b){
            return b.update_time - a.update_time;
        });
        setRows(arr);
    }
    function clickDispatchNo(dispatchNo) {
        dispatch(getDriverDispatchById(dispatchNo))
    }
    function transferDriver(driver_id, elem, id) {
        setOpen(true);
        setDriverId(driver_id);
        setTransferId(id);
        setListCate(elem);
    }
    function handleClose() {
        setOpen(false);
    }

    return (
        <>
            <DriverTransfer open={open} handleClose={handleClose} rows={rows} driverId={driverId} listCate={listCate} transferId={transferId} type={props.type}/>
            <Table>
            {   rows.length > 0 && 
                <TableHead className={classes.tableRowColor}>
                    <TableRow className={classes.tableRowColor}>
                    {
                        columns.map((title) => (
                            <TableCell align="center">{title}</TableCell>
                        ))
                    }   
                    </TableRow>
                </TableHead>
            }
                <TableBody>
                {
                    rows.length > 0 && 
                    rows.map((row, index) => (
                        <TableRow style={ index % 2? { background : "#424242" }:{ background : "#303030" } }>
                            {
                                display.map((elem) => {
                                    if(elem.includes("time")) {
                                        return (
                                            <TableCell align="center">{moment(row[elem] * 1000).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                                        )
                                    } else if(elem === "total_returned" || elem === "total_transfered" || elem === "total_unscanned") {
                                        return (
                                            <TableCell align="center" onClick={() => transferDriver(row.driver_id, elem, row.id)} style={{ cursor: 'pointer' }}>{row[elem]}</TableCell>
                                        )
                                    } else {
                                        return (
                                            <TableCell align="center">{row[elem]}</TableCell>
                                        )
                                    }
                                })    
                            }
                            <TableCell align="center">
                                {row['dispatch_no'] && <div onClick={() => clickDispatchNo(row['dispatch_no'])} style={{ cursor: 'pointer' }}>{row['dispatch_no']}</div>}
                                {row['dispatch_no1'] && <div onClick={() => clickDispatchNo(row['dispatch_no1'])} style={{ cursor: 'pointer' }}>{row['dispatch_no1']}</div>}
                                {row['dispatch_no2'] && <div onClick={() => clickDispatchNo(row['dispatch_no2'])} style={{ cursor: 'pointer' }}>{row['dispatch_no2']}</div>}
                                {row['dispatch_no3'] && <div onClick={() => clickDispatchNo(row['dispatch_no3'])} style={{ cursor: 'pointer' }}>{row['dispatch_no3']}</div>}
                                {row['dispatch_no4'] && <div onClick={() => clickDispatchNo(row['dispatch_no4'])} style={{ cursor: 'pointer' }}>{row['dispatch_no4']}</div>}
                                {row['dispatch_no5'] && <div onClick={() => clickDispatchNo(row['dispatch_no5'])} style={{ cursor: 'pointer' }}>{row['dispatch_no5']}</div>}
                            </TableCell>
                        </TableRow>
                    ))
                }
                </TableBody>
            </Table>
        </>
    );
}
export default SearchTableHistory;